import { render } from "./ModalSelecionarEntregaApresentacao.vue?vue&type=template&id=3df4315c&scoped=true"
import script from "./ModalSelecionarEntregaApresentacao.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarEntregaApresentacao.vue?vue&type=script&lang=js"

import "./ModalSelecionarEntregaApresentacao.vue?vue&type=style&index=0&id=3df4315c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df4315c"]])

export default __exports__